import { render, staticRenderFns } from "./AddEditRulesModal.vue?vue&type=template&id=09a76314"
import script from "./AddEditRulesModal.vue?vue&type=script&lang=js"
export * from "./AddEditRulesModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports